<template>
    <form class="form">
        <form class="form">
            <div class="form__item">
                <textarea class="form__input--text" v-model="question.answer" :placeholder="$t('forms.survey_template_question.open_question_answer_placeholder')" :disabled="locked"/>
            </div>
        </form>
    </form>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop, Model } from 'vue-property-decorator';

    @Component
    export default class SurveyTemplateQuestionForm extends Vue {
        @Model('change', { type: Object, default() {
            return {
                answer: ''
            };
        }})
        question;

        @Prop() locked;
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/survey/SurveyQuestionOpenForm.vue